export default __webpack_public_path__ + "static/media/business.7e36bb52.jpeg";